import { Component } from '@angular/core';

@Component({
  selector: 'hs-compare-results-info',
  templateUrl: './compare-results-info.component.html',
  styleUrls: ['./compare-results-info.component.scss']
})
export class CompareResultsInfoComponent {

}
